import type { DeepPartial } from '@luna/utils-ts';

import type { LoanFeatureConfig } from '../types/LoanFeatureConfig';

export const loans: DeepPartial<LoanFeatureConfig> = {
    overview: {
        enabled: true,
        showAdditionalInfo: true,
        showLinkedAccount: true,
        showLoanCurrency: true,
        displayDedicatedMortgageInfos: true,
    },
    additionalDetails: {
        showOverdueInfo: true,
        showExtraInstallment: true,
    },
    transactions: {
        enabled: true,
        mode: 'always',
    },
    statements: {
        enabled: true,
        mode: 'flag',
        deliveryDefinitions: {
            distribution: ['GEORGE', 'GEORGE_AND_EMAIL'],
            format: ['PDF_A4'],
            periodicity: ['DAILY', 'MONTHLY', 'YEARLY'],
            canCreateDefinition: true,
            statementNumberEditable: true,
        },
    },
    settingsDetails: {
        displayAccountOwner: true,
        displayIban: true,
        displaySlashedBBAN: true,
        displayBIC: true,
    },
    layout: {
        productInfo: {
            formatAccountNumber: true,
        },
    },
};
